export const getRecurringOrder = (state) => state.recurringOrders.singleData;

export const getRecurringOrderFetching = (state) => state.recurringOrders.fetchingSingle;

export const getActiveOrders = (state) => state.recurringOrders.activeOrders;

export const getActiveOrdersFetching = (state) => state.recurringOrders.fetchingActiveOrders;
